import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactFormSection from './components/ContactFormSection';
import { updatePageSEO } from '../../utils/seo';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: 'お問い合わせ | おかやま整形外科 - ご予約・ご相談',
      description: 'おかやま整形外科へのお問い合わせ。診療予約、ご相談、ご質問など、お気軽にお問い合わせください。電話：086-012-3456。受付時間：月〜土 9:00-18:00。',
      keywords: 'お問い合わせ, 予約, 相談, 電話番号, おかやま整形外科',
      canonical: `${siteUrl}/contact`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        name: 'お問い合わせ',
        description: 'おかやま整形外科へのお問い合わせフォーム',
        url: `${siteUrl}/contact`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ホーム',
              item: `${siteUrl}/`
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'お問い合わせ',
              item: `${siteUrl}/contact`
            }
          ]
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
